import FolderTree, { FolderTreeProps } from "components/folderTree/FolderTree";
import { Loader } from "components/loader/Loader";
import { ArchiveItem } from "models/ArchiveItem";
import { filterYearEndFolders } from "views/documents/state/documentArchiveOptions";
import { useRootStore } from "store";

import "./DocumentArchiveFolderTree.scss";

type DocumentArchiveFolderTreeProps = FolderTreeProps<ArchiveItem> & {
  isLoading: boolean;
  onFolderClicked: (node: ArchiveItem, hasChildren:boolean) => void;
};

export function DocumentArchiveFolderTree({
  isLoading,
  folders,
  onFolderClicked,
  selectedFolderId,
  ...rest
}: DocumentArchiveFolderTreeProps) {
  const { archiveRoot } = useRootStore((state) => state.archive);

  const renderLink = (node: ArchiveItem) => {
    const style = {
      marginLeft:
        "calc(var(--relative-spacing) - var(--menu-selected-item-border-width))"
    };

    return <div style={style}>{node.name}</div>;
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <FolderTree<ArchiveItem>
      onFolderClick={(node, hasChildren) => onFolderClicked(node, hasChildren)}
      selectedFolderId={selectedFolderId}
      className="ml-negative-relative document-archive-file-tree with-selected-mark"
      renderFolderNode={(node, _) => renderLink(node)}
      folders={folders.filter((item) =>
        filterYearEndFolders(item, archiveRoot)
      )}
      {...rest}
    />
  );
}
